export class RequiredFieldError extends Error {
  constructor() {
    super("This is a required field");
    this.name = "RequiredFieldError";
  }
}
